/*
import Icons from '@/components/Dashboard/Views/Icons.vue';
import Iframe from '@/components/Dashboard/Views/Iframe.vue';
import Maps from '@/components/Dashboard/Views/Maps.vue';
import Notifications from '@/components/Dashboard/Views/Notifications.vue';
*/

// Admin pages
import Overview from '@/components/Dashboard/Views/Overview.vue';
import UserProfile from '@/components/Dashboard/Views/UserProfile.vue';
import Profile from '@/components/Dashboard/Views/Profile.vue';
import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue';
import CrudComponent from '../components/Dashboard/Views/CrudComponent.vue';
import BannerComponent from '../components/Dashboard/Views/BannerComponent.vue';
import GoodieComponent from '../components/Dashboard/Views/GoodieComponent.vue';
import Login from '../components/GeneralViews/Login.vue';
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue';
import Register from '../components/GeneralViews/Register.vue';
import Reset from '../components/GeneralViews/Reset.vue';
import store from '../stores';

const authGuard = function (to, from, next) {
  if (store.state.user && store.state.user._id) {
    return next();
  }
  console.warn('Authgard:: Blocked : ', to.path, store.state.user);
  next('/login');
};

const roleGuard = role => (to, from, next) => {
  if (!store.state.user || !store.state.user._id) {
    console.warn('Rolegard::', 'User not connected, forcing logout');
    store.commit('logout');
    return next('/login');
  }

  if (!store.state.user.roles || store.state.user.roles.indexOf(role) === -1) {
    next('/');
    return;
  }
  return next();
};

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/reset-password/:token',
    name: 'Reset',
    component: Reset,
    props: true,
  },
  {
    path: '/',
    name: 'Home',
    redirect: '/app/overview',
  },
  {
    path: '/app',
    component: DashboardLayout,
    redirect: '/app/overview',
    beforeEnter: authGuard,
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: Overview,
        beforeEnter: authGuard,
      },
      {
        path: 'user',
        name: 'User',
        component: UserProfile,
        beforeEnter: authGuard,
      },
      {
        path: 'profile',
        name: 'Profile',
        component: Profile,
        beforeEnter: authGuard,
      },
      {
        path: 'product',
        component: CrudComponent,
        beforeEnter: authGuard,
        props: {
          name: 'product',
          options: {
            url: '/product',
            uploadUrl: '/product/import',
            mode: 'remote',
            filterInitiallyOn: true,
            stats: true,
            perPage: 1500,
            actions: {
              create: true,
              edit: true,
              view: true,
              delete: true,
              import: true,
              export: true,
            },
          },
        },
        children: [
          {
            name: 'View',
            path: ':id',
            component: CrudComponent,
            props: {
              name: 'product',
              url: '/product',
              uploadUrl: '/product/import',
              filterInitiallyOn: true,
              stats: true,
              options: {
                mode: 'remote',
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  import: true,
                  export: true,
                },
              },
            },
          },
          {
            name: 'Edit',
            path: ':id/edit',
            component: CrudComponent,
            props: {
              name: 'product',
              url: '/product',
              uploadUrl: '/product/import',
              stats: true,
              options: {
                mode: 'remote',
                filterInitiallyOn: true,
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  import: true,
                  export: true,
                },
              },
            },
          },
        ],
      },

      {
        path: 'stage',
        component: CrudComponent,
        beforeEnter: authGuard,
        props: {
          name: 'stage',
          options: {
            url: '/stage',
            stats: false,
            actions: {
              create: true,
              edit: true,
              view: true,
              delete: true,
              import: false,
              export: false,
            },
          },
        },
        children: [
          {
            name: 'stage_view',
            path: ':id',
            component: CrudComponent,
            props: {
              name: 'stage',
              url: '/stage',
              stats: false,
              options: {
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  import: false,
                  export: false,
                },
              },
            },
          },
          {
            name: 'stage_edit',
            path: ':id/edit',
            component: CrudComponent,
            props: {
              name: 'stage',
              url: '/stage',
              stats: false,
              options: {
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  import: false,
                  export: false,
                },
              },
            },
          },
        ],
      },

      {
        path: 'regles_de_points',
        component: CrudComponent,
        beforeEnter: authGuard,
        props: {
          name: 'regles_de_points',
          options: {
            url: '/crud/regles_de_points',
            stats: false,
            customTopRightActions: [
              {
                name: 'process-list-create',
                label: 'Mettre à jour les points',
                class: 'btn-success text-white',
                title: 'Mettre à jour les points des produits sans points',
                icon: 'fa fa-play',
                action: ({
                  items, action, location, props, id
                }, context) => {
                  // eslint-disable-next-line no-restricted-globals
                  if (confirm('Lancer la mise à jour des points ?')) {
                    context.$http.post('/product/update-points', {}).then(() => {
                      context.refreshComponent();
                    });
                  }
                },
              },
            ],
            actions: {
              create: true,
              edit: true,
              view: true,
              delete: true,
              import: true,
              export: true,
            },
          },
        },
        children: [
          {
            name: 'regles_de_points_view',
            path: ':id',
            component: CrudComponent,
            props: {
              name: 'regles_de_points',
              url: '/crud/regles_de_points',
              stats: false,
              options: {
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  import: true,
                  export: true,
                },
              },
            },
          },
          {
            name: 'regles_de_points_edit',
            path: ':id/edit',
            component: CrudComponent,
            props: {
              name: 'regles_de_points',
              url: '/crud/regles_de_points',
              stats: false,
              options: {
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  import: true,
                  export: true,
                },
              },
            },
          },
        ],
      },

      {
        path: 'barcode',
        component: CrudComponent,
        beforeEnter: authGuard,
        props: {
          name: 'barcode',
          options: {
            url: '/barcode',
            stats: false,
            actions: {
              create: true,
              edit: true,
              view: true,
              delete: true,
              import: false,
              export: false,
            },
          },
        },
        children: [
          {
            name: 'barcode_view',
            path: ':id',
            component: CrudComponent,
            props: {
              name: 'barcode',
              url: '/barcode',
              stats: false,
              options: {
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  import: false,
                  export: false,
                },
              },
            },
          },
          {
            name: 'barcode_edit',
            path: ':id/edit',
            component: CrudComponent,
            props: {
              name: 'barcode',
              url: '/barcode',
              stats: false,
              options: {
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  import: false,
                  export: false,
                },
              },
            },
          },
        ],
      },

      {
        path: 'goodie',
        component: GoodieComponent,
        beforeEnter: authGuard,
        props: {
          name: 'goodie',
          options: {
            url: '/goodie',
            uploadUrl: '/goodie/import',
            stats: true,
            actions: {
              create: true,
              edit: true,
              view: true,
              delete: true,
              import: true,
              export: true,
            },
          },
        },
        children: [
          {
            name: 'View',
            path: ':id',
            component: GoodieComponent,
            props: {
              name: 'goodie',
              url: '/goodie',
              uploadUrl: '/goodie/import',
              stats: true,
              options: {
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  import: true,
                  export: true,
                },
              },
            },
          },
          {
            name: 'Edit',
            path: ':id/edit',
            component: GoodieComponent,
            props: {
              name: 'goodie',
              url: '/goodie',
              uploadUrl: '/goodie/import',
              stats: true,
              options: {
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  import: true,
                  export: true,
                },
              },
            },
          },
        ],
      },
      {
        path: 'contact',
        component: CrudComponent,
        beforeEnter: authGuard,
        props: {
          name: 'contact',
          options: {
            url: '/contact',
            stats: true,
            actions: {
              view: true,
              delete: true,
              export: true,
            },
          },
        },
        children: [
          {
            name: 'contact_View',
            path: ':id',
            component: CrudComponent,
            props: {
              name: 'contact',
              options: {
                actions: {
                  view: true,
                  delete: true,
                  export: true,
                },
              },
            },
          },
          {
            name: 'contact_Edit',
            path: ':id/edit',
            component: CrudComponent,
            props: {
              name: 'contact',
              options: {
                actions: {
                  edit: true,
                  view: true,
                  delete: true,
                  export: true,
                },
              },
            },
          },
        ],
      },
      {
        path: 'distributor',
        component: CrudComponent,
        beforeEnter: authGuard,
        props: {
          name: 'distributor',
          options: {
            url: '/distributor',
            uploadUrl: '/distributor/import',
            stats: true,
            actions: {
              create: true,
              edit: true,
              view: true,
              delete: true,
              import: true,
              export: true,
            },
          },
        },
        children: [
          {
            name: 'distributor_View',
            path: ':id',
            component: CrudComponent,
            props: {
              name: 'distributor',
              url: '/distributor',
              uploadUrl: '/distributor/import',
              stats: true,
              options: {
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  import: true,
                  export: true,
                },
              },
            },
          },
          {
            name: 'distributor_Edit',
            path: ':id/edit',
            component: CrudComponent,
            props: {
              name: 'distributor',
              url: '/distributor',
              uploadUrl: '/distributor/import',
              stats: true,
              options: {
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  import: true,
                  export: true,
                },
              },
            },
          },
        ],
      },
      {
        path: 'company',
        component: CrudComponent,
        beforeEnter: authGuard,
        props: {
          name: 'company',
          options: {
            url: '/crud/company',
            uploadUrl: '/company/import',
            stats: true,
            actions: {
              create: true,
              edit: true,
              view: true,
              delete: true,
              import: true,
              export: true,
            },
          },
        },
        children: [
          {
            name: 'company_view',
            path: ':id',
            component: CrudComponent,
            props: {
              name: 'company',
              url: '/company',
              uploadUrl: '/company/import',
              stats: true,
              options: {
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  import: true,
                  export: true,
                },
              },
            },
          },
          {
            name: 'company_Edit',
            path: ':id/edit',
            component: CrudComponent,
            props: {
              name: 'company',
              url: '/company',
              uploadUrl: '/company/import',
              stats: true,
              options: {
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  import: true,
                  export: true,
                },
              },
            },
          },
        ],
      },
      {
        path: 'history',
        component: CrudComponent,
        beforeEnter: authGuard,
        props: {
          name: 'history',
          options: {
            url: '/history',
            stats: true,
            filterInitiallyOn: true,
            actions: {
              edit: true,
              view: true,
              export: true,
            },
          },
        },
        children: [
          {
            name: 'history_View',
            path: ':id',
            component: CrudComponent,
            props: {
              name: 'history',
              options: {
                filterInitiallyOn: true,
                actions: {
                  view: true,
                  export: true,
                },
              },
            },
          },
        ],
      },
      {
        path: 'scan_verification_request',
        component: CrudComponent,
        beforeEnter: authGuard,
        props: {
          name: 'scan_verification_request',
          url: '/scan_verification_request',
          options: {
            url: '/scan_verification_request',
            stats: true,
            customTopRightActions: [
              {
                name: 'process-list-create',
                label: 'Valider les demandes de vérification',
                class: 'btn-success text-white',
                title: 'Valide des demandes de vérification qui ont des produits associés',
                icon: 'fa fa-play',
                action: ({
                  items, action, location, props, id
                }, context) => {
                  // eslint-disable-next-line no-restricted-globals
                  if (confirm('Lancer la validation automatique ?')) {
                    context.$http.post('/scan_verification_request/validate-pending-requests', {}).then((response) => {
                      const { processed, accepted, errors, skipped } = response.data.body;
                      let message = `Résultat de la validation automatique :\n`;
                      message += `Demandes traitées: ${processed}\n`;
                      message += `Demandes validées: ${accepted}\n`;
                      message += `Erreurs: ${errors}\n`;
                      message += `Demandes ignorées: ${skipped}`;
                      return alert(message);
                    })
                    .then(() => {
                      // ici je veux rafraichir la page
                      window.location.reload();
                    })
                    .catch((error) => {
                      alert(`Erreur lors de la validation automatique. ${error.message}`);
                    });
                  }
                },
              },
            ],
            filterInitiallyOn: true,
            actions: {
              create: true,
              edit: true,
              view: true,
              export: true,
            },
          },
        },
        children: [
          {
            name: 'scan_verification_request__view',
            path: ':id',
            component: CrudComponent,
            props: {
              name: 'scan_verification_request',
              
              options: {
                url: '/scan_verification_request',
                filterInitiallyOn: true,
                actions: {
                  view: true,
                  export: true,
                },
              },
            },
          },
        ],
      },
      {
        path: 'page',
        component: CrudComponent,
        beforeEnter: authGuard,
        props: {
          name: 'page',
          options: {
            url: '/page',
            // exportUrl: '/crud/page/export',
            stats: true,
            actions: {
              create: true,
              edit: true,
              view: true,
              delete: true,
              export: true,
            },
          },
        },
        children: [
          {
            name: 'View',
            path: ':id',
            component: CrudComponent,
            props: {
              name: 'page',
              options: {
                url: '/page',
                // exportUrl: '/crud/page/export',
                stats: true,
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  export: true,
                },
              },
            },
          },
          {
            name: 'Edit',
            path: ':id/edit',
            component: CrudComponent,
            props: {
              name: 'page',
              options: {
                url: '/page',
                // exportUrl: '/crud/page/export',
                stats: true,
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                  export: true,
                },
              },
            },
          },
        ],
      },
      {
        path: 'setting',
        component: CrudComponent,
        beforeEnter: authGuard,
        props: {
          name: 'setting',
          options: {
            url: '/crud/setting',
            stats: true,
            actions: {
              create: true,
              edit: true,
              view: true,
              delete: true,
            },
          },
        },
        children: [
          {
            name: 'View',
            path: ':id',
            component: CrudComponent,
            props: {
              name: 'setting',
              options: {
                url: '/crud/setting',
                stats: true,
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                },
              },
            },
          },
          {
            name: 'Edit',
            path: ':id/edit',
            component: CrudComponent,
            props: {
              name: 'setting',
              options: {
                url: '/crud/setting',
                stats: true,
                actions: {
                  create: true,
                  edit: true,
                  view: true,
                  delete: true,
                },
              },
            },
          },
        ],
      },
      {
        path: 'company_goodie',
        component: CrudComponent,
        beforeEnter: authGuard,
        props: {
          name: 'company_goodie',
          url: '/company_goodie',
          options: {
            url: '/company_goodie',
            stats: true,
            actions: {
              view: true,
              delete: true,
              export: true,
            },
          },
        },
        children: [
          {
            name: 'View',
            path: ':id',
            component: CrudComponent,
            props: {
              name: 'company_goodie',
              options: {
                stats: true,
                actions: {
                  view: true,
                  export: true,
                },
              },
            },
          },
        ],
      },
      {
        path: 'scan_log',
        component: CrudComponent,
        beforeEnter: authGuard,
        props: {
          name: 'scan_log',
          url: '/scan-log',
          options: {
            mode: 'remote',
            url: '/scan-log',
            filterInitiallyOn: true,
            actions: {
              view: true,
              export: true,
            },
          },
        },
        children: [
          {
            name: 'View',
            path: ':id',
            component: CrudComponent,
            props: {
              name: 'scan_log',
              mode: 'remote',
              options: {
                url: '/scan-log',
                filterInitiallyOn: true,
                actions: {
                  view: true,
                  export: true,
                },
              },
            },
          },
        ],
      },
      {
        path: 'crud/:name',
        component: CrudComponent,
        props: true,
      },
      {
        path: 'banner',
        component: BannerComponent,
        children: [
          {
            name: 'View',
            path: ':id',
            component: BannerComponent,
          },
          {
            name: 'Edit',
            path: ':id/edit',
            component: BannerComponent,
          },
        ],
      },
      {
        path: 'admin/users',
        component: CrudComponent,
        beforeEnter: roleGuard('ADMIN'),
        props: {
          name: 'user',
          options: {
            stats: true,
            url: '/admin/user',
            uploadUrl: '/user/import',
            filterInitiallyOn: true,
            actions: {
              create: true,
              view: true,
              edit: true,
              export: true,
              import: true,
            },
          },
        },
      },
      {
        name: 'View',
        path: ':name/:id',
        component: CrudComponent,
        props: true,
      },
      {
        name: 'Edit',
        path: ':name/:id/edit',
        component: CrudComponent,
        props: true,
      },
    ],
  },
  {
    path: '*',
    component: NotFound,
  },
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
 };* */

export default routes;
